<div class="container">
    <div class="planContainer">
    <h2 style="text-align: center;">Plan Charts</h2>
        <canvas id="MyChart1"></canvas>
        <canvas id="MyChart2"></canvas>
        <canvas id="MyChart3"></canvas>
        <canvas id="MyChart4"></canvas>
        <canvas id="MyChart5"></canvas>
        <canvas id="MyChart6"></canvas>
        <canvas id="MyChart7"></canvas>
        <canvas id="MyChart8"></canvas>
    </div>
    <div class="parcelContainer">
    <h2 style="text-align: center;">Parcel Charts</h2>
        <canvas id="MyChart11"></canvas>
        <canvas id="MyChart12"></canvas>
        <canvas id="MyChart13"></canvas>
        <canvas id="MyChart14"></canvas>
    </div>
    </div>